const table = {
  tableColumns: [
    {
      prop: 'close_date',
      label: 'Fecha del Cierre',
    },
    {
      prop: 'ticket',
      label: 'Ticket',
    },
    {
      prop: 'city',
      label: 'Ciudad',
    },
    {
      prop: 'neighborhood',
      label: 'Barrio',
    },
    {
      prop: 'client',
      label: 'Cliente',
    },
    {
      prop: 'technician',
      label: 'Técnico',
    },
    {
      prop: 'status',
      label: 'Estado',
    },
    {
      prop: 'type',
      label: 'Tipo',
    }
  ],
  pagination: {
    perPage: 10,
    currentPage: 1,
    perPageOptions: [5, 10, 25, 50],
    total: 0
  },
}
const search = {
  pagedData () {
    return this.tableData.slice(this.from, this.to)
  },

  /***
   * Searches through table data and returns a paginated array.
   * Note that this should not be used for table with a lot of data as it might be slow!
   * Do the search and the pagination on the server and display the data retrieved from server instead.
   * @returns {computed.pagedData}
   */
  queriedData () {
    let result = this.tableData
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '')
      this.pagination.total = result.length
    }
    return result.slice(this.from, this.to)
  },

  to () {
    let highBound = this.from + this.pagination.perPage
    if (this.total < highBound) {
      highBound = this.total
    }
    return highBound
  },

  from () {
    return this.pagination.perPage * (this.pagination.currentPage - 1)
  },

  total () {
    this.pagination.total = this.tableData.length
    return this.tableData.length
  }
}
export default {table, search}
